<template>
  <div class="page">
    <div class="info">
      <div class="miniAppPic">
        <img :src="image"/>
      </div>
      <div class="miniAppDes">
        <span class="name">{{title}}</span>
        <span class="author">作者：{{author}}</span>
        <div class="category" >
          <span v-for="(item,index) in miniAppTypes" :key="index">{{item.title}}</span>
        </div>
      </div>
    </div>
    <div class="infoDetail">
      <div class="infoDetailItem">
        <span class="infoDetailTitle">{{title}}信息</span>
        <span class="infoDetailDes">发布时间：{{createTime}}</span>
      </div>
      <div class="infoDetailItem">
        <span class="infoDetailTitle">体验二维码(长按识别)</span>
        <img class="infoDetailPic" :src="codeImg"/>
      </div>
      <div class="infoDetailItem">
        <span class="infoDetailTitle">{{title}}介绍</span>
        <p class="infoDetailDes" v-html="content"></p>
      </div>
      <div class="infoDetailItem">
        <span class="infoDetailTitle">{{title}}截图</span>
        <div class="screenshotList" >
          <!--<img class="preview-img" v-for="(item, index) in miniAppShotImageViews" :key="index" :src="item.url" height="400px" @click="$preview.open(index, miniAppShotImageViews)"/>-->
          <!--<img class="preview-img screenshot" v-for="(item, index) in miniAppShotImageViews" :key="index" :src="item.url" @click="showPic(index)"/>-->
          <vue-preview class='screenshot1' :slides="previewlist" @close="handleClose"></vue-preview>
          <!--<div class="screenshotItem" v-for="(item,index) in miniAppShotImageViews" :key="index" >-->
            <!--<img class="screenshot" :src="item.url" @click="show(item.url)"/>-->
          <!--</div>-->
        </div>
      </div>
    </div>
    <modal name="previewPic" :width="this.changeWidth" :height="this.changeHeight">
      <img :src="imgName" style="width: 100%" />
    </modal>
    <!--<modal name="hello-world">-->
      <!--hello, world!-->
    <!--</modal>-->
  </div>
</template>

<script>
import WxShare from '@/libs/wx'
import TorinoSrcUtils from '@/libs/torinosrc-utils.js'
export default{
  data () {
    return {
      image: null,
      codeImg: null,
      title: '',
      author: '',
      content: '',
      createTime: '',
      miniAppTypes: [],
      miniAppShotImageViews: [],
      previewlist: [],
      imgName: '',
      visible: false,
      changeWidth: 488,
      changeHeight: 867,
      // 微信
      requestUrl: '',
      id: '',
      encodeRequestUrl: '',
      shareTitle: '',
      shareImg: '',
      shareDesc: '',
      appid: ''
    }
  },
  methods: {
    getData () {
      let that = this
      let id = this.$route.query.id
      return this.$fetch(this.$api.miniapps + '/' + id)
        .then(function (response) {
          that.image = response.data.image
          that.title = response.data.title
          that.author = response.data.author
          that.content = response.data.content
          that.codeImg = response.data.codeImg
          that.createTime = response.data.createTime
          that.createTime = TorinoSrcUtils.formatDate(
            new Date(that.createTime),
            'yyyy-MM-dd hh:mm:ss'
          )
          that.miniAppShotImageViews = response.data.miniAppShotImageViews
          that.miniAppTypes = response.data.miniAppTypes
          // const that = this
          let previewlist = []
          for (let i = 0; i < that.miniAppShotImageViews.length; i++) {
            // 获取图片实际大小
            that.imgOnload(that.miniAppShotImageViews[i].url, function (newImage) {
              previewlist.push(newImage)
            })
          }
          that.previewlist = previewlist
        })
    },
    imgOnload (url, callback) {
      let newImage = {}
      let img = new Image()
      img.src = url
      // if (img.complete) {
      //   callback()
      // } else {
      img.onload = function () {
        newImage.src = url
        newImage.msrc = url
        newImage.alt = 'picture2'
        newImage.title = 'Image Caption 2'
        newImage.w = img.width
        newImage.h = img.height
        callback(newImage)
        img.onload = null
      }
      // }
    },
    show (url) {
      this.$modal.show('previewPic')
      this.imgName = url
    },
    hide () {
      this.$modal.hide('previewPic')
    },
    handleClose () {
      console.log('close event')
    }
  },
  created () {
    let that = this
    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
      that.changeWidth = 200
      that.changeHeight = 356
    } else {
      that.changeWidth = 488
      that.changeHeight = 867
    }
  },
  mounted () {
    let that = this
    this.getData().then(function () {
      let requestUrl = window.location.href
      let shareTitle = that.title
      let shareImg = that.image
      let shareDesc = WxShare.deleteHtmlTag(that.content)
      // alert('codeImg:' + shareImg)
      let encodeRequestUrl = encodeURIComponent(requestUrl)
      if (WxShare.isWeiXin()) {
        that
          .$fetch(that.$api.weixin.signature + '?url=' + encodeRequestUrl)
          .then(function (response) {
            let signature = response.data.signature
            let timestamp = response.data.timestamp
            let noncestr = response.data.noncestr
            let appid = response.data.appId
            WxShare.init(requestUrl, shareTitle, shareImg, shareDesc, signature, appid, timestamp, noncestr)
          })
          .catch(function (err) {
            console.log(err)
          })
      }
    })
  },
  beforeRouteEnter (to, from, next) {
    var isiOS = WxShare.isIOS() // ios终端
    //    alert('isiOS: ' + isiOS)
    //    alert('to.path: ' + to.path)
    //    alert('location.pathname: ' + location.pathname)
    if (isiOS && to.path !== location.pathname) {
      location.assign(to.fullPath) // 此处不可使用location.replace
    } else {
      next()
    }
  }
}
</script>
<style>
  .my-gallery {
    display: flex;
    /*width: 1000px;*/
    flex-wrap: wrap;
  }
  .screenshot1 figure {
    margin: 0 20px 20px 0;
  }
  .screenshot1 img{
    height: 130px;
  }
  @media screen and (min-width:1024px) and (max-width: 1920px) {
    .screenshot1 figure {
      margin: 0 20px 20px 0;
    }
    .screenshot1 img{
      height: 340px;
    }
  }
</style>

<style scoped>
  @import '../../../assets/css/miniApp/miniAppDetail.css';
</style>



// WEBPACK FOOTER //
// src/pages/miniapp/miniAppDetail/miniAppDetail.vue